export default "__VITE_ASSET__j$7jJ3Lu__"